import { Component, OnInit } from '@angular/core';
import { FooterComponent } from 'libs/shared/src/lib/component/layout/footer/footer.component';
import { environment } from 'apps/cinema1/src/environments/environment';

@Component({ standalone: false, selector: 'app-footer', templateUrl: './footer.component.html' })
export class CustomFooterComponent extends FooterComponent implements OnInit {
  env = environment;
  year = new Date().getFullYear();

  constructor() {
    super(environment);
  }

  ngOnInit() {}
}
